define("shared/components/shared/social/facebook-picker", ["exports", "@ember/component", "@ember/template-factory", "@ember/array", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency"], function (_exports, _component, _templateFactory, _array, _service, _component2, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/array",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.pagesLoading}}
    <div class="o--loadingWrapper">
      <div class="o--loading"></div>
    </div>
  {{else}}
    {{! Pages }}
    <p class="u--text--md u--text--bold">{{t "account.controllers.groups.facebook.pages"}}</p>
    <div class="u--row u--m__t">
      {{#each this.pages as |page|}}
        <div class="u--col__6 u--p__r__sm u--p__b__sm">
          <Shared::Social::FacebookPage @addPage={{perform this.addPage page}} @page={{page}} />
        </div>
      {{/each}}
    </div>
  {{/if}}
  */
  {
    "id": "1af6UoS8",
    "block": "[[[41,[30,0,[\"pagesLoading\"]],[[[1,\"  \"],[10,0],[14,0,\"o--loadingWrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--loading\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,2],[14,0,\"u--text--md u--text--bold\"],[12],[1,[28,[35,1],[\"account.controllers.groups.facebook.pages\"],null]],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--row u--m__t\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"pages\"]]],null]],null],null,[[[1,\"      \"],[10,0],[14,0,\"u--col__6 u--p__r__sm u--p__b__sm\"],[12],[1,\"\\n        \"],[8,[39,4],null,[[\"@addPage\",\"@page\"],[[28,[37,5],[[30,0,[\"addPage\"]],[30,1]],null],[30,1]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[1]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]]]],[\"page\"],false,[\"if\",\"t\",\"each\",\"-track-array\",\"shared/social/facebook-page\",\"perform\"]]",
    "moduleName": "shared/components/shared/social/facebook-picker.hbs",
    "isStrictMode": false
  });

  let FacebookPickerComponent = (_dec = (0, _service.inject)('social/instagram-business'), _dec2 = (0, _service.inject)('social/connect-profiles'), (_class = class FacebookPickerComponent extends _component2.default {
    get pagesLoading() {
      return this.instagramBusiness.fetchFacebookPages.isRunning || this.args.isAddFacebookProfileRunning;
    }

    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "errors", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor4, this);

      _initializerDefineProperty(this, "connectProfiles", _descriptor5, this);

      _initializerDefineProperty(this, "pages", _descriptor6, this);

      this._fetchFacebookPages();
    }

    *addPage(page) {
      try {
        const scopes = this.connectProfiles.authResponse.grantedScopes;
        yield this.args.addProfile(page.id, page.access_token, scopes ? scopes.split(',') : null);
        this.args.closeFacebook();
      } catch (error) {
        this.alerts.warning(this.intl.t('alerts.account.controllers.groups.facebook.add_error'));
        this.errors.log(error, page);
      }
    }

    async _fetchFacebookPages() {
      this.pages = (0, _array.A)(await this.instagramBusiness.fetchFacebookPages.perform());
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pages", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addPage", [_emberConcurrency.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "addPage"), _class.prototype)), _class));
  _exports.default = FacebookPickerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FacebookPickerComponent);
});